<template>
  <v-row>
    <v-col cols="12">
      <v-data-table
        :headers="headers"
        :items="items"
        :loading="loading"
        :footer-props="{ itemsPerPageOptions: [5, 10, 25, 50] }"
      >
        <template v-slot:item.isDefault="{ item }">
          <v-chip v-if="item.isDefault" small color="primary" dark>
            {{ $t('listaPreciosVenta.labels.isDefault') }}
          </v-chip>
        </template>
        <template v-slot:item.formula="{ item }">
          <span class="text-caption">{{ item.formulaConfig && item.formulaConfig.formula }}</span>
        </template>
        <template v-slot:item.margenDefault="{ item }">
          <span>{{ item.formulaConfig && item.formulaConfig.margenDefault != null ? item.formulaConfig.margenDefault + '%' : '—' }}</span>
        </template>
        <template v-slot:item.tipoRedondeo="{ item }">
          <span>{{ tipoRedondeoLabel(item.formulaConfig && item.formulaConfig.tipoRedondeo) }}</span>
        </template>
        <template v-slot:item.action="{ item }">
          <edit-button @click="$emit('update', item)" />
          <delete-button v-if="!item.isDefault" @click="$emit('delete', item)" />
        </template>
        <template slot="no-data">
          <div class="text-xs-center" v-t="'common.noData'"></div>
        </template>
      </v-data-table>
    </v-col>
  </v-row>
</template>

<script>
import ListaPreciosVentaProvider from "../../../providers/ListaPreciosVentaProvider";
import { EditButton, DeleteButton } from "@dracul/common-frontend";

export default {
  name: "ListaPreciosVentaList",
  components: { EditButton, DeleteButton },
  data() {
    return {
      items: [],
      loading: false,
    };
  },
  computed: {
    headers() {
      return [
        { text: this.$t('listaPreciosVenta.labels.nombre'), value: 'nombre' },
        { text: this.$t('listaPreciosVenta.labels.isDefault'), value: 'isDefault', sortable: false },
        { text: this.$t('listaPreciosVenta.labels.formula'), value: 'formula', sortable: false },
        { text: this.$t('listaPreciosVenta.labels.margenDefault'), value: 'margenDefault', sortable: false },
        { text: this.$t('listaPreciosVenta.labels.tipoRedondeo'), value: 'tipoRedondeo', sortable: false },
        { text: this.$t('common.actions'), value: 'action', sortable: false },
      ];
    },
  },
  created() {
    this.fetch();
  },
  methods: {
    fetch() {
      this.loading = true;
      ListaPreciosVentaProvider.list()
        .then((r) => {
          this.items = r.data.listaPreciosVentaList || [];
        })
        .catch((err) => console.error(err))
        .finally(() => (this.loading = false));
    },
    tipoRedondeoLabel(tipo) {
      if (!tipo) return this.$t('listaPreciosVenta.labels.sinOverride');
      return this.$t('listaPreciosVenta.labels.' + tipo);
    },
  },
};
</script>
